import { render, staticRenderFns } from "./build_mobex_health_plus.vue?vue&type=template&id=6521c0e4&scoped=true"
import script from "./build_mobex_health_plus.vue?vue&type=script&lang=js"
export * from "./build_mobex_health_plus.vue?vue&type=script&lang=js"
import style0 from "./build_mobex_health_plus.vue?vue&type=style&index=0&id=6521c0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521c0e4",
  null
  
)

export default component.exports